import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  VStack,
} from '@chakra-ui/react'
import { ChakraPrimaryButton } from 'components/Button'

interface MedicationFollowupModalProps {
  isOpen: boolean
  onClose: () => void
  responseType: 'POSITIVE' | 'CONCERNING'
  providerName: string
  handleBookAppointmentRedirect: () => void
  followupMdAppointmentTypeId?: string
}

const MEDICATION_FOLLOW_UP_CONTENT = {
  POSITIVE: {
    title: "You're on the right track!",
    message:
      "We'll update your records with this information. If you would like to reach out or have any questions, feel free to schedule time with %provider_name%.",
    buttonText: 'Book appointment',
  },
  CONCERNING: {
    title: "We're here to help",
    message:
      'It sounds like you might need some support in your care journey. %provider_name%, your medical provider, is here to help.',
    buttonText: 'Book appointment',
  },
}

const MedicationFollowupModal: React.FC<MedicationFollowupModalProps> = ({
  isOpen,
  onClose,
  responseType,
  providerName,
  handleBookAppointmentRedirect,
  followupMdAppointmentTypeId,
}) => {
  const content = MEDICATION_FOLLOW_UP_CONTENT[responseType]

  const getFormattedMessage = (message: string, providerName: string) => {
    return message.replace('%provider_name%', providerName)
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="md"
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent maxW="432px">
        <ModalHeader
          borderBottom="none"
          fontSize="24px"
          fontWeight="500"
          lineHeight="32px"
          color="var(--blue-dark)"
          p="24px"
        >
          {content.title}
          <ModalCloseButton
            fontWeight="400"
            color="#9091A4"
            pt="28px"
            pr="24px"
          />
        </ModalHeader>
        <ModalBody pb="24px">
          <VStack align="stretch" spacing={6}>
            <Text fontSize="16px" fontWeight="500" color="var(--blue-dark)">
              {getFormattedMessage(content.message, providerName)}
            </Text>
            <ChakraPrimaryButton
              onClick={handleBookAppointmentRedirect}
              disabled={!followupMdAppointmentTypeId}
            >
              {content.buttonText}
            </ChakraPrimaryButton>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default MedicationFollowupModal
